import { Model, View } from '@lernetz/ts-lib';

import template from './ManualTwoColumnLayout.html';

export class ManualTwoColumnLayout extends Model {

    public readonly firstElements: object[];
    public readonly secondElements: object[];
    public readonly marginTop: string;
    public readonly marginBottom: string;
    public readonly width: string;

    public constructor(dto) {
        super();

        this.firstElements = dto.firstElements || [];
        this.secondElements = dto.secondElements || [];
        this.marginTop = dto.marginTop || '';
        this.marginBottom = dto.marginBottom || '';
        this.width = dto.width || '';
    }
}

export class ManualTwoColumnLayoutView extends View<ManualTwoColumnLayout> {

    public constructor() {
        super({ template });
    }
}
